import { LightningElement, api } from "lwc";
import { c as classNames } from "tds/chunk_index";
import { attrToBool } from "common/helpers";

class textarea extends LightningElement {
  @api placeholder = null;
  @api name = null;
  @api label = null;
  @api disabled = false;
  @api required = false;
  @api rows = "5";
  @api errorMessage = null;
  @api ariaLabel = null;
  @api maxLength = null;
  @api value = "";

  @api focus() {
    this.template.querySelector("textarea")?.focus();
  }

  get className() {
    return classNames("textarea", {
      "textarea--disabled": this.isDisabled,
      "textarea--errored": this.errorMessage,
    });
  }

  get isDisabled() {
    return attrToBool(this.disabled);
  }

  get isRequired() {
    return attrToBool(this.required);
  }

  handleChange(e) {
    this.dispatchEvent(
      new CustomEvent("change", {
        detail: e.target.value,
      })
    );
  }
}

export default textarea;
